module.exports = __webpack_public_path__ + "media/particles.2803fa7a.mp4";